// extracted by mini-css-extract-plugin
export default {"torrent":"ProtocolLabel-torrent-Fhltw Label-label-DYldh","usenet":"ProtocolLabel-usenet-HVp5Y Label-label-DYldh","unknown":"ProtocolLabel-unknown-gwrqY Label-label-DYldh"};